module.exports = __webpack_public_path__ + "img/kao1.ab10b04a.png";